import { createRoot } from 'react-dom/client'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import App from './App.tsx'
import PresentationPCDF from './pages/PresentationPCDF.tsx'
import './index.css'

createRoot(document.getElementById('root')!).render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/apresentacao-pcdf" element={<PresentationPCDF />} />
    </Routes>
  </BrowserRouter>,
)
